<div class="page-number-selector">
    <div class="text">{{ 'sentEmails.showLabel' | t }}</div>
    <cerrix-select
        class="page-select"
        [options]="options"
        [showNone]="false"
        [(ngModel)]="selected"
        (ngModelChange)="onChange($event)"
    >
    </cerrix-select>
    <div class="text">{{ 'sentEmails.entriesLabel' | t }}</div>
</div>
